<script>
import { Doughnut } from "vue-chartjs";
export default {
  extends: Doughnut,
  props: ["datas", "options"],
  mounted() {
    this.renderChart(this.datas, this.options);
  }
};
</script>
